export const mergeIntervals = (intervals) => {
    const result = [...intervals];
    result.sort(([a], [c]) => a - c);
    let i = 1;
    while (i < result.length) {
        const [a, b] = result[i - 1];
        const [c, d] = result[i];
        if (b >= c) {
            result.splice(i - 1, 2, [a, Math.max(b, d)]);
        }
        else {
            i++;
        }
    }
    return result;
};
//# sourceMappingURL=mergeIntervals.js.map